import type { DashboardDto } from "@stryker/core/types/dashboard";

import BarChart from "./charts/BarChart";
import { sortByFromBiggestJobs } from "./utils";

type JobsCountProps = {
  graphsData?: DashboardDto["jobs"];
};
export default function JobsCount({ graphsData }: JobsCountProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <BarChart
        data={graphsData?.byPlantName?.toSorted(sortByFromBiggestJobs) ?? []}
        dataKey="plantName"
        barDataKey="jobs"
        barName="by plant"
        color="orange"
        title="Jobs count by plant"
      />
      <BarChart
        data={
          graphsData?.byBranch
            ?.map(({ branch, jobs }) => {
              return {
                jobs,
                label: branch ?? "N/A",
              };
            })
            ?.toSorted(sortByFromBiggestJobs) ?? []
        }
        dataKey="label"
        barDataKey="jobs"
        barName="by branch"
        color="blue"
        title="Jobs count by branch"
      />
      <BarChart
        data={
          graphsData?.byKitsSize
            ?.map((v) => {
              return { ...v, label: v.kitSize };
            })
            .toSorted(sortByFromBiggestJobs) ?? []
        }
        dataKey="label"
        barDataKey="jobs"
        barName="by kits size"
        hideX
        color="green"
        title="Jobs count by kits size"
      />
      <BarChart
        data={graphsData?.byPerson?.toSorted(sortByFromBiggestJobs) ?? []}
        dataKey="person"
        barDataKey="jobs"
        hideX
        barName="by person"
        color="purple"
        title="Jobs count by person"
      />
      <BarChart
        data={graphsData?.byRepairSystem?.toSorted(sortByFromBiggestJobs) ?? []}
        dataKey="repairSystem"
        barDataKey="jobs"
        barName="by repair system"
        color="violet"
        hideX
        title="Jobs count by repair system"
      />
    </div>
  );
}
